module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_5012.0c423ff2.png";